// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteRangesIndicator_container__uDwLA"};